module.exports = __webpack_public_path__ + "img/bananuman-400px.fcd0e94b.png";